import { render, staticRenderFns } from "./ActivityStream.vue?vue&type=template&id=2ce8863d&scoped=true&"
import script from "./ActivityStream.vue?vue&type=script&lang=js&"
export * from "./ActivityStream.vue?vue&type=script&lang=js&"
import style0 from "./ActivityStream.vue?vue&type=style&index=0&id=2ce8863d&lang=scss&scoped=true&"
import style1 from "./ActivityStream.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8863d",
  null
  
)

export default component.exports